const variantUpdateEvents = ['variant:update', 'shopify:product:select'];

class StockAlerts extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    this.status = this.querySelector('[data-stock-alert-status]');
    this.section = this.closest('.shopify-section, dialog');
    this.form?.addEventListener('submit', this.handleSubmit);
    variantUpdateEvents.forEach((eventName) => {
      this.section?.addEventListener(eventName, this.handleVariantUpdate);
    });
    this.syncAvailability();
  }

  disconnectedCallback() {
    this.form?.removeEventListener('submit', this.handleSubmit);
    variantUpdateEvents.forEach((eventName) => {
      this.section?.removeEventListener(eventName, this.handleVariantUpdate);
    });
  }

  /** @param {SubmitEvent} event */
  handleSubmit = async (event) => {
    event.preventDefault();
    if (!this.form || this.dataset.available === 'true') return;

    const email = new FormData(this.form).get('email');
    const button = this.form.querySelector('button');
    if (typeof email !== 'string' || !this.form.reportValidity()) return;

    if (button) button.disabled = true;
    this.setStatus('Saving your alert…');

    try {
      const response = await fetch('/apps/stock-alerts/subscribe', {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify({ email, variantId: this.dataset.variantId }),
      });

      if (response.status === 409) {
        this.setStatus('This item is already available.');
        return;
      }
      if (!response.ok) throw new Error('Subscription request failed');
      this.form.reset();
      this.setStatus("You're all set. We'll email you when this item is back in stock.");
    } catch {
      this.setStatus('We could not save your alert. Please try again.');
    } finally {
      if (button) button.disabled = false;
    }
  };

  /** @param {Event & { detail?: { data?: { html?: Document } }, promise?: Promise<{ detail?: { html?: Document } }> }} event */
  handleVariantUpdate = (event) => {
    if (event.promise) {
      event.promise
        .then(({ detail }) => this.updateFromHtml(detail?.html))
        .catch((error) => {
          if (error?.name !== 'AbortError') this.setStatus('Please try another option.');
        });
      return;
    }

    this.updateFromHtml(event.detail?.data?.html);
  };

  /** @param {Document | undefined} html */
  updateFromHtml(html) {
    const replacement = html?.querySelector(`stock-alerts[data-block-id="${this.dataset.blockId}"]`);
    if (!replacement) return;

    this.dataset.variantId = replacement.dataset.variantId;
    this.dataset.available = replacement.dataset.available;
    this.setStatus('');
    this.syncAvailability();
  }

  syncAvailability() {
    const unavailable = this.dataset.available !== 'true' && Boolean(this.dataset.variantId);
    if (this.form) this.form.hidden = !unavailable;
    if (!unavailable) this.setStatus('');
  }

  /** @param {string} message */
  setStatus(message) {
    if (this.status) this.status.textContent = message;
  }
}

if (!customElements.get('stock-alerts')) {
  customElements.define('stock-alerts', StockAlerts);
}
